import { render } from "./MiniPreloader.vue?vue&type=template&id=00b23f85&scoped=true"
import script from "./MiniPreloader.vue?vue&type=script&lang=js"
export * from "./MiniPreloader.vue?vue&type=script&lang=js"

import "./MiniPreloader.vue?vue&type=style&index=0&id=00b23f85&lang=css&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b23f85"]])

export default __exports__